import axiosInstance from './axiosInstance';

const getSettings = async ({ token }) => {
  try {
    const response = await axiosInstance.post(
      '/settings',
      {},
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {getSettings};